export const dateFormat = "D/M/YYYY";
export const dateWithHourFormat = dateFormat + " H:mm A";
export const hourFormat = "H:mm A";